// src/components/LayerGroupIcon.jsx

import React from "react";
import PropTypes from "prop-types";
import "../styles/LayerGroupIcon.css"; // We'll create this CSS file next

const LayerGroupIcon = ({ onClick, ariaLabel, title, className }) => (
  <svg
    aria-hidden="true"
    focusable="false"
    data-prefix="fal"
    data-icon="layer-group"
    role="img"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    className={`layer-group-icon ${className || ""}`}
    onClick={onClick}
    aria-label={ariaLabel}
    title={title}
    role={onClick ? "button" : "img"}
    tabIndex={onClick ? 0 : undefined}
    onKeyPress={
      onClick
        ? (e) => {
            if (e.key === "Enter") onClick();
          }
        : undefined
    }
  >
    <path
      fill="currentColor"
      d="M266.2 4.7C273 1.6 280.5 0 288 0s15 1.6 21.8 4.7l217.4 97.5c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 251.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 153.9C38.6 149.3 32 139.2 32 128s6.6-21.3 16.8-25.9L266.2 4.7zM288 32c-3 0-6 .6-8.8 1.9L69.3 128l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-210-94.1C294 32.6 291 32 288 32zM48.8 358.1l45.9-20.6 39.1 17.5L69.3 384l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 507.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 409.9C38.6 405.3 32 395.2 32 384s6.6-21.3 16.8-25.9zM94.7 209.5l39.1 17.5L69.3 256l210 94.1c2.8 1.2 5.7 1.9 8.8 1.9s6-.6 8.8-1.9l210-94.1-64.5-28.9 39.1-17.5 45.9 20.6c10.2 4.6 16.8 14.7 16.8 25.9s-6.6 21.3-16.8 25.9L309.8 379.3c-6.9 3.1-14.3 4.7-21.8 4.7s-15-1.6-21.8-4.7L48.8 281.9C38.6 277.3 32 267.2 32 256s6.6-21.3 16.8-25.9l45.9-20.6z"
      className=""
    ></path>
  </svg>
);

LayerGroupIcon.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};

LayerGroupIcon.defaultProps = {
  onClick: null,
  ariaLabel: "Layer Group Icon",
  title: "Layer Group",
  className: "",
};

export default LayerGroupIcon;
